import StepWizard from '../../../commons/StepWizard/StepWizard';
import { useNavigate, useParams } from 'react-router-dom';
import { useCurrentUser } from '../../../../hooks/useCurrentUser/useCurrentUser';
import { useEffect } from 'react';
import { UserRoles } from '../../../../types/models/user/user.types';
import { newRegisterSteps } from './RegisterSteps.data';
import '../../../../styles/Register.css';

export default () => {
  const { role } = useParams<{ role: UserRoles }>();

  const navigate = useNavigate();

  const currentUser = useCurrentUser();

  useEffect(() => {
    if (currentUser) {
      if (
        role === UserRoles.AcheteurPublic &&
        currentUser.id_step >= newRegisterSteps[UserRoles.AcheteurPublic].length
      ) {
        navigate('/');
      }
      if (
        role === UserRoles.Entreprise &&
        currentUser.id_step >= newRegisterSteps[UserRoles.Entreprise].length
      ) {
        navigate('/dashboard');
      }
    }
  }, [currentUser]);

  const steps = newRegisterSteps[role ? role : UserRoles.AcheteurPublic];

  return <StepWizard {...{ steps }} isCompany={role === UserRoles.Entreprise} />;
};
